export const ONBOARDING_TOOLTIPS = {
  // Company Identification
  nume_entitate:
    "Denumirea entității. Se va completa numele complet al entității conform actelor constitutive.",
  cui: "Se va completa CUI (sau CIF pentru entitățile care nu dețin CUI) în funcție de tipul entității. Se completează fără atributul fiscal atașat (RO sau alt prefix literar), adică NUMAI partea numerică.",
  nr_inregistrare:
    "Registrul comerțului sau similar. Se va preciza Registrul comerțului sau alte registre, respectiv Registrul asociațiilor și fundațiilor; Registrul federațiilor etc.",
  adresa:
    "Adresa completă a sediului social, conform datelor oficiale din Registrul Comerțului sau ANAF.",
  email:
    "Se vor utiliza NUMAI e-mailuri instituționale. Este interzisă utilizarea de e-mailuri comerciale în relația cu DNSC.",
  caen_principal:
    "Codul activității economice principale (clasificare CAEN Rev.2). Se preia automat din ANAF sau se completează manual.",
  caen_secundar:
    "Se vor înscrie toate CAEN-urile secundare autorizate care au corespondență în anexele 1 și 2 din OUG nr. 155/2024. Obligatoriu, se va înscrie clasa CAEN, respectiv 4 cifre (exemplu: 1106). Se adaugă câte un cod pe rând.",

  // Financial Data
  nr_salariati:
    "Numărul mediu anual de salariați, conform Legii nr. 346/2004 privind stimularea înființării și dezvoltării întreprinderilor mici și mijlocii (Art. 5-7).",
  cifra_afaceri:
    "Cifra de afaceri anuală netă (EUR), conform Legii nr. 346/2004 privind stimularea înființării și dezvoltării întreprinderilor mici și mijlocii (Art. 6-7).",
  active:
    "Activele totale deținute (EUR), conform Legii nr. 346/2004 privind stimularea înființării și dezvoltării întreprinderilor mici și mijlocii (Art. 6-7).",

  // Contacts
  reprezentant_legal:
    "Persoana cu drept de reprezentare legală a entității, conform actelor constitutive.",
  responsabil_securitate:
    "Se vor avea în vedere prevederile art. 14 alin. (3) și alin. (4), respectiv obligativitatea pentru entitățile esențiale și voluntariat pentru celelalte entități.",
  contact_operational:
    "Persoana de contact permanentă pentru monitorizarea și răspunsul la incidente de securitate cibernetică.",
  email_contact:
    "Se vor utiliza NUMAI e-mailuri instituționale. Este interzisă utilizarea de e-mailuri personale în relația cu DNSC.",
  adrese_ip:
    "Se va înscrie fiecare interval în formă de rețea (CIDR) — câte un interval pe rând (exemplu: 100.106.171.93/32, 10.66.198.88/29).",
  sisteme_afectate:
    "Descrieți sistemele informatice și rețelele care intră sub incidența NIS2 (sisteme esențiale pentru serviciile furnizate).",

  // Entity State Relation
  stabilita_in_romania:
    "Entitatea este înființată și înregistrată pe teritoriul României conform prevederilor legale. Conceptul de stabilire implică pur și simplu exercitarea efectivă a unei activități prin intermediul unei instalații permanente, indiferent de forma juridică adoptată, fie că este vorba de sediul social sau o filială cu personalitate juridică.",
  sediu_principal_in_romania:
    "În înțelesul OUG nr. 155/2024, sediul principal se determină astfel: a) sediul în care se iau deciziile legate de măsurile de gestionare a riscurilor în materie de securitate cibernetică în mod predominant; b) dacă nu se poate stabili cf. a), sediul în care își desfășoară operațiunile de securitate cibernetică; c) dacă nu se poate stabili cf. b), statul în care entitatea are sediul cu cel mai mare număr de angajați. NOTĂ: Nu puteți avea sediul principal în România și să nu fiți stabilit în România în același timp.",
  entitate_administratie_publica:
    "Entitățile din administrația publică centrală și locală care îndeplinesc criteriile de risc intră sub incidența NIS2.",
  entitate_critica_294_2024:
    "Entitatea este/a fost identificată ca entitate critică în România (conform Legii nr. 294/2024 privind reziliența entităților critice).",
  entitate_extra_ue:
    "Entitățile stabilite în afara UE care furnizează servicii pe teritoriul UE trebuie să desemneze un reprezentant în unul din statele membre unde furnizează servicii.",

  // EU Services
  furnizeaza_servicii_romania:
    "Indicați dacă entitatea furnizează servicii care cad sub incidența NIS2 pe teritoriul României.",
  furnizeaza_servicii_ue:
    "Dacă furnizați servicii în mai multe state membre UE, este posibil să fiți supus unor obligații de notificare și în acele state.",
  state_membre_ue:
    "Se vor înscrie statele membre UE în care se furnizează servicii NIS2, împreună cu adresele sediilor din acele state (dacă este cazul).",
  adresa_sediu_ue:
    "Adresa sediului din statul respectiv (opțional). Formatul: strada număr, cod poștal localitatea — exemplu: Via Garibaldi 25, 00184 Roma RM. Nu se trec sediile din România.",

  // Classification
  clasificare_esentiala:
    "Entitățile din sectoarele cu criticitate ridicată (Anexa I) de dimensiune medie sau mare. Supuse celor mai stricte obligații de securitate și raportare.",
  clasificare_importanta:
    "Entitățile din Anexa I de dimensiune mică sau din sectoarele critice (Anexa II) de dimensiune medie sau mare.",
  clasificare_out_of_scope:
    "Entitatea nu îndeplinește criteriile de includere în domeniul de aplicare al NIS2.",
} as const;
